import { useTranslation } from 'react-i18next';
import { HOSTFULLY_ASSIST_DETAILS_PATH } from '../../HostfullyAssist.constants';
import { HOSTFULLY_ASSIST_SCHEDULE_DEMO_URL } from '../HostfullyAssistMarketing.constants';
import {
  ClosingBackdrop,
  ClosingCard,
  ClosingInner,
  ClosingSectionWrapper,
  ComparisonCard,
  ComparisonFootnote,
  ComparisonLabel,
  ComparisonNote,
  ComparisonRow,
  ComparisonSide,
  ComparisonValue,
  CtaRow,
  Overline,
  OutlineCtaLink,
  PrimaryCtaLink,
  SectionHeading,
  VersusLabel,
} from '../HostfullyAssistMarketing.styles';

const ClosingSection = () => {
  const { t } = useTranslation();

  return (
    <ClosingSectionWrapper data-testid="assist-closing">
      <ClosingBackdrop aria-hidden />
      <ClosingInner>
        <ClosingCard>
          <div>
            <Overline>
              {t('pageHostfullyAssist.marketing.closing.overline')}
            </Overline>
            <SectionHeading>
              {t('pageHostfullyAssist.marketing.closing.headline')}
            </SectionHeading>
          </div>
          <CtaRow>
            <OutlineCtaLink
              href={HOSTFULLY_ASSIST_SCHEDULE_DEMO_URL}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="assist-closing-cta-demo"
            >
              {t('pageHostfullyAssist.marketing.cta.scheduleDemo')}
            </OutlineCtaLink>
            <PrimaryCtaLink
              to={HOSTFULLY_ASSIST_DETAILS_PATH}
              data-testid="assist-closing-cta-try-free"
            >
              {t('pageHostfullyAssist.marketing.cta.tryForFree')}
            </PrimaryCtaLink>
          </CtaRow>
          <ComparisonCard>
            <ComparisonRow>
              <ComparisonSide>
                <ComparisonLabel>
                  {t(
                    'pageHostfullyAssist.marketing.closing.comparison.before.label',
                  )}
                </ComparisonLabel>
                <ComparisonValue>
                  {t(
                    'pageHostfullyAssist.marketing.closing.comparison.before.value',
                  )}
                </ComparisonValue>
                <ComparisonNote>
                  {t(
                    'pageHostfullyAssist.marketing.closing.comparison.before.note',
                  )}
                </ComparisonNote>
              </ComparisonSide>
              <VersusLabel>
                {t('pageHostfullyAssist.marketing.closing.comparison.versus')}
              </VersusLabel>
              <ComparisonSide>
                <ComparisonLabel>
                  {t(
                    'pageHostfullyAssist.marketing.closing.comparison.after.label',
                  )}
                </ComparisonLabel>
                <ComparisonValue>
                  {t(
                    'pageHostfullyAssist.marketing.closing.comparison.after.value',
                  )}
                </ComparisonValue>
                <ComparisonNote>
                  {t(
                    'pageHostfullyAssist.marketing.closing.comparison.after.note',
                  )}
                </ComparisonNote>
              </ComparisonSide>
            </ComparisonRow>
            <ComparisonFootnote>
              {t('pageHostfullyAssist.marketing.closing.comparison.footnote')}
            </ComparisonFootnote>
          </ComparisonCard>
        </ClosingCard>
      </ClosingInner>
    </ClosingSectionWrapper>
  );
};

export default ClosingSection;
